import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import {variableGlobal} from './../global.enum'
import {DocumentoMarting} from '../model/ventaModel'
import {BusinessPartner} from '../model/BusinessPartnerModel'
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SapService {

  constructor(
    private _http: HttpClient,
  ) { }

  async GeneraDocumentoMarketing(objeto: DocumentoMarting) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
  
    const body = {
      "documento": objeto,
      "respuesta": {
        "estado": true,
        "TOKEN": variableGlobal.TOKEN,
        "mensaje": "",
        "resultado": null
      }
    };
  
    
    return this._http.post(environment.RUTA_API + '/api/SAP/GeneraDocumentoMarketing', body, { headers }).toPromise();
  }
  
  async GeneraDocumentoMarketingDesdeBorrador(preliminal)
  {
    const body =
    {
      estado: false,
      TOKEN: variableGlobal.TOKEN,
      resultado: preliminal
    }
    
    return this._http.post(environment.RUTA_API + '/api/SAP/GeneraDocumentoMarketingDesdeBorrador', body).toPromise();
  }
  async ObtenerDocumentoMarketing(objeto:DocumentoMarting)
  {
    const body =
    {
      "documento": objeto,
      "respuesta": {"estado": true, "TOKEN": variableGlobal.TOKEN, "mensaje": "", "resultado": null}
    }

    return this._http.post(environment.RUTA_API + '/api/SAP/ObtenerDocumentoMarketing', body).toPromise();
  }
  async ObtenerDocumentoMarketingLITE(objeto:DocumentoMarting)
  {
    const body =
    {
      "documento": objeto,
      "respuesta": {"estado": true, "TOKEN": variableGlobal.TOKEN, "mensaje": "", "resultado": null}
    }

    
    return this._http.post(environment.RUTA_API + '/api/SAP/ObtenerDocumentoMarketingLITE', body).toPromise();
  }

  async GeneraSocioNegocio(objeto:BusinessPartner)
  {
    const body =
    {
      "socio": objeto,
      "respuesta": {"estado": true, "TOKEN": variableGlobal.TOKEN, "mensaje": "", "resultado": null}
    }

    return this._http.post(environment.RUTA_API + '/api/SAP/GeneraSocioNegocio', body).toPromise();
  }
  async ObtenerSocioNegocio(objeto) // objeto: BusinessPartner
  {
    const body =
    {
      "socio": objeto,
      "respuesta": {"estado": true, "TOKEN": variableGlobal.TOKEN, "mensaje": "", "resultado": null}
    }
    
    return this._http.post(environment.RUTA_API + '/api/SAP/ObtenerSocioNegocio', body).toPromise();
  }

  async ObtenerSocioNegocioEdita(objeto) // objeto: BusinessPartner
  {
    const body =
    {
      "socio": objeto,
      "respuesta": {"estado": true, "TOKEN": variableGlobal.TOKEN, "mensaje": "", "resultado": null}
    }
    
    return this._http.post(environment.RUTA_API + '/api/SAP/ObtenerSocioNegocioEdita', body).toPromise();
  }

  async ObtenerMaestroTarifarios()

  {
    const body = {
      "respuesta": {
          "estado": true,
          "TOKEN": "INDESAD",
          "mensaje": "",
          "resultado": null
      }
  }


    return this._http.post(environment.RUTA_API + '/api/SAP/obtieneItems', body).toPromise();
  }
  async ObtenerItemMT(itemcode)

  {
    const body = {
      "respuesta": {
        "estado": true,
        "TOKEN": "INDESAD",
        "mensaje": "",
        "resultado": null
    },
    "item": {
        "ItemCode": itemcode
    }
  }


    return this._http.post(environment.RUTA_API + '/api/SAP/obtieneItem', body).toPromise();
  }

  async CrearEditarMT(data)

  {
    const body = {
      "respuesta": {
          "estado": true,
          "TOKEN": "INDESAD",
          "mensaje": "",
          "resultado": null
      },
      "item": data
  }

    

    return this._http.post(environment.RUTA_API + '/api/SAP/generaActualizaMaestroArticulo', body).toPromise();
  }

  async EliminarMT(data)

  {
    const body = {
          "respuesta": {
        "estado": true,
        "TOKEN": "INDESAD",
        "mensaje": "",
        "resultado": null
    },
    "item": {
        "ItemCode": data.ItemCode
    }
  }

    return this._http.post(environment.RUTA_API + '/api/SAP/eliminaMaestroArticulo', body).toPromise();
  }

  async obtieneListaMaterial(code)
  {
    const body = {
      "TOKEN": "INDESAD",
      "resultado":{
          "Code": code
      }
  }
    return this._http.post(environment.RUTA_API + '/api/SAP/obtieneListaMaterial', body).toPromise();
  }

  async creaActualizaListaMaterial(item)
  {
    const body = {
      "estado": true,
      "mensaje": "Lista de materiales item",
      "TOKEN": "INDESAD",
      "resultado": item
    }
    return this._http.post(environment.RUTA_API + '/api/SAP/creaActualizaListaMaterial', body).toPromise();
  }

  async obtieneOportunidad(id)
  {
    const body =
    {
      "TOKEN": "INDESAD",
      "resultado":{
          "OpprId": id
      }
    }
    return this._http.post(environment.RUTA_API + '/api/SAP/obtieneOportunidad', body).toPromise();
  }

  async creaActualizaOportunidad(objeto)
  {
    const body =
    {
      "TOKEN": "INDESAD",
      "resultado": objeto
    }

    
    return this._http.post(environment.RUTA_API + '/api/SAP/creaActualizaOportunidad', body).toPromise();
  }

  async obtieneActividad(code)
  {
    const body =
    {
      "TOKEN": "INDESAD",
      "resultado":{
          "ClgCode": code
      }
  }
    return this._http.post(environment.RUTA_API + '/api/SAP/obtieneActividad', body).toPromise();
  }


  async creaActualizaActividad(objeto)
  {
    const body =
    {
      "TOKEN": "INDESAD",
      "resultado": objeto
  }

    return this._http.post(environment.RUTA_API + '/api/SAP/creaActualizaActividad', body).toPromise();
  }

  async verAdjunto(objeto)
  {
    const body =
    {
      "TOKEN": "INDESAD",
      "resultado": objeto
  }

    return this._http.post(environment.RUTA_API + '/api/SAP/verAdjunto', body).toPromise();
  }

  async creaActualizaAdjunto(AbsEntry,base64Data,fileName,fileExt)
  {
    const body =
    {
      "TOKEN": "INDESAD",
      "resultado": [
        {
          AbsEntry: AbsEntry,
          srcPath: base64Data,
          FileName: fileName,
          FileExt: fileExt
        }
      ]
  }

  

    return this._http.post(environment.RUTA_API + '/api/SAP/creaActualizaAdjunto', body).toPromise();
  }

  async obtieneOportunidadModel(id:any)
  {
    const body =
    {
      "TOKEN": "INDESAD",
      "resultado":{
          "ID": id
    }

  }
    return this._http.post(environment.RUTA_API + '/api/SAP/obtieneOportunidadModel', body).toPromise();
  }

  async obtieneOportunidadExcel(id:any)
  {
    const body =
    {
      "TOKEN": "INDESAD",
      "resultado":{
          "ID": id
      }
    }
    

    return this._http.post(environment.RUTA_API + '/api/SAP/obtieneOportunidadExcel', body).toPromise();
  }

}
